import { Helmet } from 'react-helmet-async';

const SITE_URL = process.env.REACT_APP_SITE_URL || 'https://opcionesargentinas.com';

const schema = {
  '@context': 'https://schema.org',
  '@type': 'TravelAgency',
  name: 'Opciones Argentinas',
  url: SITE_URL,
  logo: `${SITE_URL}/Icono_OA.svg`,
  description: 'Agencia de turismo líder en salidas grupales desde 1993. Paquetes nacionales e internacionales.',
  address: {
    '@type': 'PostalAddress',
    addressCountry: 'AR',
  },
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'customer service',
    url: `${SITE_URL}/contacto`,
  },
};

function OrganizationSchema() {
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
}

export default OrganizationSchema;
